export default "__VITE_ASSET__BW0R3XXy__"